<mat-icon class="arrow" *ngIf="canShowArrow()" [style.top.px]="arrowPosition.y" [style.left.px]="arrowPosition.x" svgIcon="atoms-arrow"></mat-icon>

<section #matCardElement>
  <vdw-header
    [title]="'GENERAL.ACTIONS.EDIT_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.PATH' | bmsTranslate: {count: 1} | lowercase}"
    [canShowClose]="true"
    (closeEvent)="close()"
  ></vdw-header>
  <vdw-footer chooseEventName="GENERAL.ACTIONS.DELETE" [centered]="true" [withCancelButton]="false" (chooseEvent)="deleteProductionSchedulePathOfColoredYarnSet()"></vdw-footer>
</section>
